
import { useEffect, useState } from 'react';
import NotificationHandler from '../../../../../../../../../../utils/NotificationHandler';
// import PreviewFileModal from '../../../../../../../../../shared/PreviewFile/PreviewFileModal';
import { enumUtil } from '../../../../../../../../../../utils/Enum';
import { ServerRequestPublic } from '../../../../../../../../../../utils/ServerDataRequest';
import Loader from '../../../../../../../../../shared/Loader/Loader';
import PreviewImage from '../../Preview Image/PreviewImage';

const File = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {
    const API_URL_Wasabi = enumUtil.controller.Wasabi;

    const IMAGE_TYPES = ['image/png', 'image/jpeg', "image/tiff"];
    const [dragActive, setDragActive] = useState(false);
    const [previewModalActive, setPreviewModalActive] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [FileType, setFileType] = useState('');
    const [FileToPreview, setFileToPreview] = useState('');

    useEffect(() => {
        if (item.file) {
            const value = item.file?.trim();
            console.log("FileToPreview", value, item.answer && value.includes(item.answer))
            const isBucketPath = item.answer && value.includes(item.answer);
            if (isBucketPath) {
                ViewPdf(item.file);
            } else {
                let type = getMimeType(item?.answer)
                setFileType(type);
                setFileToPreview(`data:${getMimeType(item.answer)};base64,${value}`);
            }
        }
    }, [item.file])

    const getMimeType = (fileName = "") => {
        const ext = fileName?.split(".")?.pop()?.toLowerCase();

        if (ext === "png") return "image/png";
        if (ext === "jpg" || ext === "jpeg") return "image/jpeg";
        if (ext === "tiff" || ext === "tif") return "image/tiff";
        return "image/png"; // fallback
    };

    const ViewPdf = (data) => {
        setFileType(null)
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', { "BucketPath": data }, 'Download')
            .then((response) => {
                setIsLoading(false)
                let type = getMimeType(item?.answer)
                setFileType(type);

                if (IMAGE_TYPES.includes(type)) {
                    const blob = response
                    const objectURL = URL.createObjectURL(blob);
                    setFileToPreview(objectURL)
                }
                else {
                    let file = new Blob([response]);
                    const fileUrl = URL.createObjectURL(file);
                    setFileToPreview(fileUrl)
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
            })
    }

    const openPopup = () => {
        if (!item.file) return;
        setPreviewModalActive(true)
    }

    const onClose = () => {
        setPreviewModalActive(false)
    }

    let PreviewModal = "";
    if (previewModalActive) {
        PreviewModal = <PreviewImage modalActive={previewModalActive} onClose={onClose} item={FileToPreview} type={FileType} isLoading={isLoading} />
    }

    return (
        <>
            <div className="d-flex gap-10">
                <div className="ar-form-counter flex-center">
                    <p className='text text-black'>{props?.itemCount}</p>
                </div>
                <div className="d-flex flex-column gap-6">
                    {isLoading ? <Loader /> : null}
                    {PreviewModal}
                    <p className="heading fs-13">
                        {/* {item.content} */}
                        {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
                    </p>
                    <div className="sign-content d-flex align-items-center justify-content-center p-1" onClick={() => openPopup()}>
                        <img
                            src={FileToPreview}
                            alt={`${item?.answer || 'Img'}`}
                        />
                    </div>
                </div>
            </div>
        </>
    )

}

export default File;